import { type FunctionComponent } from 'react';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { type PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { StyledButton } from '../../buttons';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';

export const SecondaryPromoC: FunctionComponent<PromoBannerVariationOptions> = ({
	headline,
	subHeading,
	couponCode,
	expirationDate,
	action,
	image,
	imageShade,
	imageOverlay
}) => {
	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 300,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});

	return (
		<div className="ba b--theme-grey-light pa3">
			<div className="b f4 theme-primary">{headline}</div>
			<div className="flex mv3">
				<div className="mr2 w-50">
					<div className="f6 lh-title theme-grey-darker">{subHeading}</div>
					{(couponCode || expirationDate) && (
						<div className="f7 mv2 theme-grey-darker lh-copy">
							<DoorMarker />
							{defaultCouponExpirationString(couponCode, expirationDate)}
						</div>
					)}
				</div>
				<BannerImage
					className="min-h4 ml2 relative w-50 flex items-center justify-center"
					backgroundUrl={backgroundUrl}
					imageShade={imageShade}
					preload={false}>
					{imageOverlay && (
						<CloudinaryImage
							publicID={imageOverlay.id}
							description="promo"
							className="bottom-0 left-0 max-h-100 pa3"
							options={{
								width: 80,
								height: undefined,
								crop: 'lfill',
								gravity: 'custom',
								preserveTransparency: true
							}}
							useDimensions={false}
						/>
					)}
				</BannerImage>
			</div>
			{action && (
				<div className="w-100">
					<StyledButton size="LARGE">{action?.name || ''}</StyledButton>
				</div>
			)}
		</div>
	);
};
